import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[matInput][type="date"]' // 精準匹配
})
export class DisableDateKeyboardDirective2 {
  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    console.log(2);
    event.preventDefault();
  }
}
